export const BALANCE_SHOW = "BALANCE_SHOW";
export const BALANCE_HIDE = "BALANCE_HIDE";
export const BALANCE_CLEAN = "BALANCE_CLEAN"